import React, { useContext } from "react";
import { DollarContext } from "../contexts/DollarContext";
import { FaEdit } from "react-icons/fa";
import lockIcon from "../assets/lockIcon.png";
import pdfIconGray from "../assets/pdfIconGray.png";
import { useState } from "react";

import checkedOffIcon from "../assets/checkedOffIcon.png";
import checkedOnIcon from "../assets/checkedOnIcon.png";
import { formatarValor } from "./OrderTable";
import { FaTrash } from "react-icons/fa";
import api from "../services/api";
import { useNavigate, useParams } from "react-router-dom";

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
const TableAddedPayments = ({
  payments,
  setListPayments,
  setOrder,
  setAverageDollarPrice,
}) => {
  const [downloadStates, setDownloadStates] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [dollarValue, setDollarValue] = useState(0);
  const [selectPaymentId, setSelectPaymentId] = useState(null);

  const { id } = useParams();

  const handleToggleDownload = (id) => {
    setDownloadStates((prevStates) => ({
      ...prevStates,
      [id]: !prevStates[id],
    }));
  };

  const handleDeletePayment = async (id, amount) => {
    try {
      await api.delete(`/payments/${id}`);
      setListPayments((prevState) =>
        prevState.filter((payment) => payment.id !== id)
      );

      setOrder((prevState) => ({
        ...prevState,
        amount_left: prevState.amount_left + Number(amount),
        status: payments.length > 1 ? prevState.status : "PEDIDO_FEITO",
      }));
    } catch (error) {
      console.error("Erro ao excluir pagamento: ", error);
    }
  };

  const handleConfirmPayment = async () => {
    try {
      const response = await api.patch(
        `/payments/set-is-paid/${selectPaymentId}`,
        {
          isPaid: true,
          dollarValue,
        }
      );

      setListPayments((state) =>
        state.map((payment) =>
          payment.id === selectPaymentId
            ? { ...payment, isPaid: true }
            : payment
        )
      );

      setAverageDollarPrice(response.data.weightedOrderDollarAverage);

      const paymentAmount = payments.find(
        (payment) => payment.id === selectPaymentId
      ).payment_amount;

      setOrder((prevState) => ({
        ...prevState,
        amount_left: prevState.amount_left - Number(paymentAmount),
      }));
    } catch (error) {
      console.log("Erro ao confirmar pagamento: ", error);
    }
  };
  const handleCancelPaymentConfirmation = async (id) => {
    try {
      await api.patch(`/payments/set-is-paid/${id}`, {
        isPaid: false,
      });

      setListPayments((state) =>
        state.map((payment) =>
          payment.id === id ? { ...payment, isPaid: false } : payment
        )
      );

      const paymentAmount = payments.find(
        (payment) => payment.id === id
      ).payment_amount;

      setOrder((prevState) => ({
        ...prevState,
        amount_left: prevState.amount_left + Number(paymentAmount),
      }));
    } catch (error) {
      console.log("Erro ao confirmar pagamento: ", error);
    }
  };

  return (
    <div>
      <table className="w-full text-boldGray opacity-90">
        <thead className="w-full table-auto border-collapse">
          <tr className="uppercase bold text-base text-center">
            <th className=" p-4 w-[5%]"></th>
            <th className=" p-4 w-[25%]">Data</th>
            <th className=" p-4 w-[30%]">Descrição</th>
            <th className=" p-4 w-[25%]">Valor pago</th>
            <th className=" p-4 w-[5%] "></th>
            <th className=" p-4 w-[5%] "></th>
            <th className=" p-4 w-[5%] "></th>
          </tr>
        </thead>
        <tbody className="space-y-4">
          {payments.map((item, index) => (
            <React.Fragment key={index}>
              <tr className="text-center bg-[#E7E7E7] w-full h-[64px] cursor-pointer ">
                <td className=" py-4 font-bold w-[5%]">
                  <button
                    onClick={() => {
                      setSelectPaymentId(item.id);
                      setDollarValue(item.exchange_rate);
                      item.isPaid
                        ? handleCancelPaymentConfirmation(item.id)
                        : setIsModalOpen(true);
                    }}
                  >
                    <div className="w-full h-full flex justify-center items-center">
                      {item.isPaid ? (
                        <img
                          src={checkedOffIcon}
                          alt="ícone checked marcado "
                        />
                      ) : (
                        <img
                          src={checkedOnIcon}
                          alt="ícone checked desmarcado"
                        />
                      )}
                    </div>
                  </button>
                </td>
                <td className=" py-4 w-[20%]">
                  <div className="line-clamp-2">
                    {formatDate(item.payment_date)}
                  </div>
                </td>
                <td className=" py-4 w-[30%]">
                  <div className="line-clamp-2">{item.description}</div>
                </td>
                <td className=" py-4 w-[20%]">
                  {formatarValor(item.payment_amount, "USD")}
                </td>
                <td className=" py-4 w-[5%]">
                  <div className="w-full">
                    <img src={pdfIconGray} alt="ícone pdf" />
                  </div>
                </td>
                <td className="w-[5%]">
                  <div className="flex items-center justify-center mt-4">
                    <div className="relative inline-flex">
                      <button
                        onClick={() => handleToggleDownload(item.id)}
                        className={`rounded-full w-10 h-5 p-1 flex items-center cursor-pointer ${
                          downloadStates[item.id]
                            ? "bg-orange-400"
                            : "bg-gray-300"
                        }`}
                      >
                        <div
                          className={`rounded-full w-4 h-4 bg-white transition-transform ${
                            downloadStates[item.id]
                              ? "transform translate-x-5"
                              : ""
                          }`}
                        ></div>
                      </button>
                      <img
                        src={lockIcon}
                        alt="Lock icon"
                        className="ml-2 w-4 h-4"
                      />
                    </div>
                  </div>
                </td>
                <td className="w-[5%] ">
                  {/* <button
                    type="button"
                    onClick={() =>
                      handleDeletePayment(item.id, item.payment_amount)
                    }
                  >
                    <FaTrash className="ml-7 text-red-600 " />
                  </button> */}

                  <button
                    type="button"
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate(
                        `/pedidos/detalhes/${id}/editar-pagamento/${item.id}`
                      );
                    }}
                    className=" "
                  >
                    <FaEdit className="ml-7 mt-4" />
                  </button>
                </td>
              </tr>

              {index !== payments.length - 1 && (
                <tr>
                  <td className="h-[6px]"></td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-lg w-[400px]">
            <h2 className="text-lg font-bold mb-4">Confirmação de pagamento</h2>
            <p className="mb-2">Insira o valor do dólar de fechamento:</p>
            <input
              type="number"
              step={0.01}
              value={dollarValue}
              min={1}
              onChange={(e) => setDollarValue(e.target.value)}
              className="border border-gray-300 p-2 w-full rounded"
            />
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  handleConfirmPayment();
                  setIsModalOpen(false);
                }}
                className="px-4 py-2 bg-orange-500 text-white rounded"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableAddedPayments;
